module.exports = __webpack_public_path__ + "img/rank_star_3.dc68f4af.png";